import { routes } from "routes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideAllMenus } from "store/application/application-action";
import { useQuery } from "hooks/useQuery";

import "./styles/TrendingTag.scss";

interface ITrendingTagsProps {
  title: string;
  setSearchInput: (arg: string) => void;
  setCurrentTag: (arg: string[]) => void;
}

export const TrendingTag = ({ title, setSearchInput, setCurrentTag }: ITrendingTagsProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const query = useQuery();

  const handleClickSearchItem = () => {
    setSearchInput("");
    // @ts-ignore
    setCurrentTag(prev => {
      if (prev.includes(title)) {
        navigate(routes.multipleTag(prev, query.get("order") ?? undefined, !!query.get("verified")));
        return prev;
      }

      if (prev.length >= 3){
        return prev;
      }

      navigate(routes.multipleTag([...prev, title], query.get("order") ?? undefined, !!query.get("verified")));
      return [...prev, title];
    });
    document?.getElementById("global-search-input")?.blur();
    dispatch(hideAllMenus());
  };

  return (
    <div className="TrendingTag" onClick={handleClickSearchItem}>
      <div className="TrendingTag-Circle" />
      <span>{ title }</span>
    </div>
  );
};
